import { useCallback } from 'react';
import useDriftClient from 'src/hooks/useDriftClient';
import useDriftAccountsStore from 'src/stores/useDriftAccountsStore';

export const useUnsubscribeClients = () => {
	const driftClient = useDriftClient();

	const unsubscribeClients = useCallback(async () => {
		const accountStore = useDriftAccountsStore.getState().get();

		const unsubscribeUserClientsPromises = Object.values(
			accountStore.accounts
		).map((account) => {
			return account?.client?.unsubscribe() ?? Promise.resolve();
		});
		await Promise.all(unsubscribeUserClientsPromises);

		if (driftClient) await driftClient.unsubscribe();
	}, [driftClient]);

	return { unsubscribeClients };
};
